// @ts-expect-error - Automatic, Please fix when editing this file
const getCodeType = (offer) => offer?.canBeRedeemedWithPromoCode?.[0]?.codeType;

export default getCodeType;
